

// export default MultiStepper;
import { randomUUID } from "../../utils/randomUUID";
import "./MultiStepper.css";
import { userDataState } from "../../atoms/dashboard";
import { useRecoilValue  } from "recoil";
import { groupBy } from "../../pages/PresentationServices";
import PopOver from "../PopOver/PopOver";

const MultiStepper = (props) => {
  const usrData = useRecoilValue(userDataState);
  const grpLevel=groupBy(['levals']);
  const { levels: steps, jdmMappingId, streamName,divisionName,level } = props?.data;
  const datlevl =  grpLevel(steps[0]);
  const currentStep = parseInt(usrData?.jobLevelID);
  let finRes= Object.keys(datlevl);
  const endRes=finRes.push("LL")
  console.log("finRes",finRes);
  console.log("finRes",endRes);
  const complete = false;

  return (
    <>
      <div className="flex items-center justify-start mt-2 h-[130px]">
        <div className="flex justify-between relative">
          {finRes?.sort().map((step,i, steps) => (
            <>    
            {console.log('datpop>>',currentStep,i,steps.length)}   
            {i+1!=steps.length ?      
            <div key={randomUUID()} className={`step-item ${divisionName != usrData?.divisionName && 'other-division-step'}  ${(step == usrData?.jobLevelName && divisionName == usrData?.divisionName) && "active"} ${(i +1 == steps.length && divisionName == usrData?.divisionName) &&"complete"} `}>
            
              {(i + 1) % 2 == 0 &&
                <div className={`step-name w-[200px] text-[11px] font-semibold text-center mb-[5px]`}>
                  {/* {step} */}
                  {step.split('-')[1]}
                </div>}
                <PopOver content={<div className="moves_list">{datlevl[step].map((valus)=>{return <p>{valus.levl_vals}</p>})}</div>} direction="right">
                               
                {console.log('datpop11>>',currentStep,i+1,steps.length,step,level)}  
              <div className={`step ${i +1 == steps.length && "last-step"} ${divisionName != usrData?.divisionName && 'other-step'} ${(level == step ) && "next-level"} ${!step.length > 0 &&
                  "empty"} ${(i + 1) % 2 == 0 ? 'mb-[7px]' : 'mt-[7px]'}`}>              
                {/* {`L${i + 1}`} */}
                {step.split('-')[0]}
              </div>
              </PopOver>
                {(i + 1) % 2 !== 0 &&
                <div className={`step-name w-[200px] text-[11px] font-semibold text-center mt-[5px]`}>
                  {/* {step} */}
                  {step.split('-')[1]}
                </div>}
              {(step == usrData?.jobLevelName && divisionName == usrData?.divisionName) && (
                <span className={`you-are-here ${ (i + 1) % 2 == 0 ? "lower" : "upper" }`}>
                  YOU ARE HERE
                </span>
              )}
            {/* </div> : <div key={randomUUID()} className={`step-item grey-bg hidden`}>
            
          
              <div className={`step `}>
               
              </div>
         
          </div> */}
             </div> : ""
            }
            </>
          ))}
          <div className="grid place-items-center grid-cols-3 w-[395px] hidden">
          {/* <span className=" h-1 w-32 bg-slate-600"></span> */}
            <h2 className="text-[12px] whitespace-nowrap w-[180px]">Maximum level attained</h2>
            <span className=" h-2 w-32 bg-[#cacacc]"></span>
          </div>
        </div>
      </div >
    </>
  );
};



export default MultiStepper;
